import type { WorldLevel } from '@/queries/constants'
import type { UserContextType } from '@/client/context/user'

// As long as worldSlug is not retrieved using query builder (recommended retrieve from url),
// this helper is safe to use as a conditional input into queries.
export default function getUserLevelInWorld({
  user,
  worldSlug,
}: {
  user: UserContextType
  worldSlug: string
}): WorldLevel | null {
  const worlds = Object.values(user.worlds)
  const levelsBySlug = Object.fromEntries(worlds.map(({ slug, level }) => [slug, level]))

  return levelsBySlug[worldSlug]
}
